export const FilterConfig = {
  device: {
    fieldNames: ['getOriginatorAgentAlias', 'getDestinationAgentAlias'],
    source: 'equal'
  },
  status: {
    fieldNames: ['getTestStatus'],
    source: 'includes'
  },
  testtype: {
    fieldNames: ['getTestType'],
    source: 'equal'
  },
  name: {
    fieldNames: ['getName'],
    source: 'equal'
  }
};
